import { NgModule } from '@angular/core';
import { AppApiModule } from '../services/api.module';
import { SharedModule } from '../shared/shared.module';

import { WelcomeStateModule } from './welcome-state.module';

import { WelcomeComponent } from './components/welcome/welcome.component';
import { WelcomeShellComponent } from './containers/welcome-shell/welcome-shell.component';

@NgModule({
  imports: [
    SharedModule,
    AppApiModule,
    WelcomeStateModule,
  ],
  declarations: [
    WelcomeComponent,
    WelcomeShellComponent,
  ],
  exports: [
  ]
})
export class WelcomeModule { }
